import { useTranslation } from "next-i18next";

import { Currency } from "@/Apollo/schema";

/** The apps' picker labels, from the same Lokalise keys (WHO-5145, WHO-5143). */
const CURRENCY_NAMES: Record<Currency, { key: string; defaultValue: string }> =
  {
    [Currency.Eur]: {
      key: "common:currency-name-eur",
      defaultValue: "Euro (€)",
    },
    [Currency.Gbp]: {
      key: "common:currency-name-gbp",
      defaultValue: "British Pound (£)",
    },
    [Currency.Usd]: {
      key: "common:currency-name-usd",
      defaultValue: "US Dollar ($)",
    },
  };

export const DisplayCurrencyName = ({ currency }: { currency: Currency }) => {
  const { t } = useTranslation();
  const { key, defaultValue } = CURRENCY_NAMES[currency];

  return <>{t(key, defaultValue)}</>;
};
